import { DesignModules, MenuSections } from 'components/email-layout/constants'
import { HeaderLogoWidth } from 'components/email-layout/edit-sections/headerandlogo'
import { MenuItem, TabMenu } from 'components/tab-menu/component'
import { RasaContext } from 'context'
import React from 'react'
import { connect } from 'react-redux'
import { Input } from 'reactstrap'
import * as Router from 'router'
import { Roles } from 'shared/constants'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import * as Flash from 'components/flash'
import * as Modals from 'shared/modals'
import '../../../email-layout/styles.scss'
import { FooterEdit } from 'components/email-layout/edit-sections/footer'
import { Loading } from 'components/loading'
import { Dataset } from 'generic/dataset'
import { BaseClientEntity } from 'generic/baseClientEntity'
interface TemplateCodesEditState extends Modals.ModalComponentState {
  code?: string,
  originalCode?: string,
  communityPartnerId?: string,
  codeCreated?: boolean,
  configs: any,
  emailLayoutId: string,
  emailLayout: any,
  isDirty: boolean
  isLoading: boolean,
  selectedTab?: string,
  isSuperUser: boolean,
  codeValidationError?: string,
  existingCodes?: string[],
}
enum ConfigMenus {
  GENERAL = 'general',
  HEADER = 'header',
  FOOTER = 'footer',
}

interface TemplateCodesEditProps extends Modals.ModalComponentProps {
  onLayoutChange: any,
  communityId: string,
  emailLayoutId: string,
  emailLayout: any,
  onSaveSuccess?: () => void,
}
class TemplateCodesEditModal extends Modals.GenericModalComponent<TemplateCodesEditProps, TemplateCodesEditState> {
  public static key: string = 'templateCodesEdit'
  public static contextType = RasaContext
  private sharedStore: SharedStore

  constructor(props: TemplateCodesEditProps) {
    super(props, TemplateCodesEditModal.key)
    this.state = {
      code: '',
      originalCode: '',
      communityPartnerId: '',
      codeCreated: false,
      configs: {},
      emailLayoutId: '',
      emailLayout: {},
      isDirty: false,
      isLoading: true,
      selectedTab: ConfigMenus.GENERAL,
      isSuperUser: false,
      codeValidationError: '',
      existingCodes: [],
    }
  }

  public componentDidMount = () => {
    this.sharedStore = SharedStore.instance(this.context)
    Promise.all([
      this.sharedStore.getValue(SharedKeys.role),
      this.sharedStore.getValue(SharedKeys.activeCommunity),
    ]).then(([role, activeCommunity]) => {
      this.loadExistingSegmentCodes(activeCommunity.communityId)
        .then((existingCodes) => {
          this.setState({
            isSuperUser: role === Roles.super_admin,
            existingCodes: existingCodes || [],
          })
        })
    })
  }

  private loadExistingSegmentCodes(communityId: string): Promise<string[]> {
    return new Dataset()
      .loadCommunityDataset('communityPartnerSegmentCode', communityId, [{param: 'includeDefaultOptions', value: 1}])
      .then((response) => {
        if (!response || !response[0]) {
          return []
        }
        return response[0].map((item) => item.code.toLowerCase())
      })
      .catch(() => {
        return []
      })
  }

  public componentDidUpdate(prevProps: any, prevState: any) {
    const data = this.props.data[this.key].data
    if (data.community_partner_code !== prevProps.data[this.key].data.community_partner_code) {
      this.setState({
        isLoading: true,
        code: data.community_partner_code,
        originalCode: data.community_partner_code,
        communityPartnerId: data.community_partner_id,
      })
    return Promise.all([
      new Dataset().loadCommunityDataset('communityConfigurationsByPartnerCode',
        this.props.communityId,
        [{param: 'communityPartnerCodeVal', value: encodeURIComponent(data.community_partner_code)}]),
      this.loadExistingSegmentCodes(this.props.communityId),
    ]).then(([cpConfigs, existingCodes]) => {
        if (cpConfigs[0].length > 0) {
          const objConfig = cpConfigs[0].reduce((acc, curr) => ({...acc, [curr.key]: curr.value}), {})
          this.setState({
            emailLayout: objConfig,
            existingCodes: existingCodes || [],
            isLoading: false,
          })
        } else {
          this.setState({
            emailLayout: {},
            existingCodes: existingCodes || [],
            isLoading: false,
          })
        }
      })
    }
  }

  protected renderChildren(data: any) {
    return this.state.isLoading ? <Loading size='16' /> : <div>
      <div>
        <TabMenu menus={this.configMenus()}
          selectedItemKey={this.state.selectedTab}
          onSelect={(item: MenuItem) => {
            this.setState({
              selectedTab: item.key,
            })
          }}/>
      </div>
      {this.state.selectedTab === ConfigMenus.GENERAL ?
        <div className="bottom-wrapper">
          <div className="small-title">
            Segment Code
          </div>
          <div className="url-rectangle-wrapper">
            <div className="url-right-element">
              <Input value={this.state.code || ''}
                     placeholder="Enter segment code..."
                     disabled={!this.state.isSuperUser}
                     onChange={(e) => {
                       e.preventDefault()
                       const newCode = e.target.value
                       const isDuplicate = newCode &&
                                          newCode.toLowerCase() !== this.state.originalCode.toLowerCase() &&
                                          this.state.existingCodes.includes(newCode.toLowerCase())
                       this.setState({
                         code: newCode,
                         isDirty: newCode !== this.state.originalCode,
                         codeValidationError: isDuplicate ? 'Segment code already exists. Please choose a different code.' : ''
                       })
                     }}/>
              <br></br>
            </div>
          </div>
          {this.state.codeValidationError && (
            <div className="text-danger validation-error-message">
              {this.state.codeValidationError}
            </div>
          )}
        </div>
      : this.state.selectedTab === ConfigMenus.HEADER ?
        <HeaderLogoWidth data={this.state.emailLayout}
          name={MenuSections.headerAndLogo}
          designModules={[DesignModules.headerLogo]}
          onChange={(field: string, value: string) => this.updateConfig(field, value)} />
      :
      <FooterEdit data={this.state.emailLayout}
        modals={this.props.data}
        openModal={this.props.openModal}
        closeModal={this.props.closeModal}
        name={MenuSections.footer}
        designModules={[DesignModules.footerLogo]}
        onChange={(field: string, value: string) => this.updateConfig(field, value)} />}
    </div>
  }
  private updateConfig = (field, value) => {
    this.setState({
      configs: {
        ...this.state.configs,
        [field]: value
      },
      isDirty: true,
      emailLayout: {
        ...this.state.emailLayout,
        [field]: value,
      }
    })
    // this.props.onLayoutChange(field, value)
  }
  private configMenus = (): MenuItem[] => {
    const menus = [
      {
        name: 'General',
        key: ConfigMenus.GENERAL,
        component: null,
      },
      {
        name: 'Header',
        key: ConfigMenus.HEADER,
        component: null,
      },
      {
        name: 'Footer',
        key: ConfigMenus.FOOTER,
        component: null,
      },
    ]
    return menus
  }

  protected getSaveText(): string {
    return 'Save'
  }

  protected saveDisabled(): boolean {
    return !this.state.isDirty || !!this.state.codeValidationError
  }

  protected onModalClose(data: any) {
    this.setState({
      selectedTab: ConfigMenus.GENERAL,
    })
    this.props.closeModal(this.key)
  }

  protected doSave(data: any) {
    const promises: Promise<any>[] = []

    // Update segment code if changed
    if (this.state.code !== this.state.originalCode) {
      const communityPartnerPromise = this.context.entityMetadata
        .getEntityObject('communityPartner')
        .then((communityPartnerEntityObject: BaseClientEntity) => {
          communityPartnerEntityObject.setRecordId(this.props.communityId, this.state.communityPartnerId)
          communityPartnerEntityObject.data.communityIdentifier = this.props.communityId
          communityPartnerEntityObject.data.code = this.state.code
          return communityPartnerEntityObject.save()
        })
      promises.push(communityPartnerPromise)
    }

    // Update email layout configurations if any changed
    if (Object.keys(this.state.configs).length > 0) {
      const emailLayoutPromise = this.context.entityMetadata.getEntityObject('email_layout', this.props.communityId, this.props.emailLayoutId)
        .then((emailLayoutEntityObject: BaseClientEntity) => {
          Object.keys(this.state.configs).forEach((key) => {
            const value = this.state.configs[key]
            emailLayoutEntityObject.data[key] = value
          })
          emailLayoutEntityObject.data.community_partner_code = this.state.code || data.community_partner_code
          return emailLayoutEntityObject.save()
        })
      promises.push(emailLayoutPromise)
    }

    return Promise.all(promises)
      .then(() => {
        this.context.store.dispatch(Flash.showFlashMessage('Template configuration saved successfully!'))
        if (this.props.onSaveSuccess) {
          this.props.onSaveSuccess()
        }
      })
      .catch((error) => {
        const errorMessage = (error && error.response && error.response.error && error.response.error.message) ||
                           (error && error.message) ||
                           'Failed to save template configuration. Please try again.'
        this.context.store.dispatch(Flash.showFlashError(errorMessage))
        throw error // Re-throw to prevent modal from closing
      })
  }
}

export const EditTemplateCodesModal = connect(
  null,
  {
    push: Router.push,
  },
)(TemplateCodesEditModal)
